import script from "./giftlist.vue?vue&type=script&setup=true&lang=js"
export * from "./giftlist.vue?vue&type=script&setup=true&lang=js"

import "./giftlist.vue?vue&type=style&index=0&id=2a602c28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a602c28"]])

export default __exports__